import React, { useState, useContext, useEffect, useCallback } from 'react';
import GameConfigContext from '../../../contexts/GameConfigContext/GameConfigContext';
import ConfigContext from '../../../contexts/ConfigContext/ConfigContext';
import { saveGameTime } from '../../../api';
import { PanelBox, SmileBox } from './Panel.css';
import DigitalNumber from '../../../Digital/Digital';

const Panel = (): JSX.Element => {
  const { gameConfig, setGameConfig, loadNewGame } = useContext(GameConfigContext);
  const { config, setConfig } = useContext(ConfigContext);
  const [startTime, setStartTime] = useState(0);
  const [timer, setTimer] = useState(0);
  const intervalRef = React.useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (gameConfig.started) {
      setTimer(0);
      intervalRef.current = setInterval(() => {
        setTimer(time => time + 1);
      }, 1000);
      setStartTime(Date.now());
    }
  }, [gameConfig.started]);

  useEffect(() => {
    // if (gameConfig.reloaded) {
      setTimer(0);
      setStartTime(0);
      if (intervalRef.current)
        clearInterval(intervalRef.current);
    // }
  }, [gameConfig.reloaded])

  useEffect(() => {
    if (gameConfig.gameOver) {
      if (intervalRef.current)
        clearInterval(intervalRef.current);
      if (gameConfig.win) {
        void (async function() {
          const endTime = Date.now() - startTime;
          setConfig({...config, user: {...config.user, lastGames: [{ id: 0, level: gameConfig.difficult, time: endTime, userId: config.user.id, date: 0 }, ...config.user.lastGames]}})
          setGameConfig({...gameConfig, gameTime: endTime});
          await saveGameTime(config.user.id, gameConfig.difficult, endTime);
        })();
      }
    }
  }, [gameConfig.gameOver]);

  const handleTryLoadNewGame = useCallback(() => {
    // if (gameConfig.gameOver && !gameConfig.win) {
      setTimer(0);
      // setStartTime(0);
      // setEndTime(0);
      if (intervalRef.current)
        clearInterval(intervalRef.current);
      loadNewGame();
    // }
  }, [gameConfig]);

  return (
    <PanelBox>
      <div style={{height: 40, width: 70}}>
        <DigitalNumber
          nums={('00' + (gameConfig.bombCount - gameConfig.flagCount).toString()).slice(-3)}
          color='#FF0000'
          unActiveColor='#22221e'
          backgroundColor='#000000'
          transform
          transformDuration={0}
        />
      </div>
      <div>
        <SmileBox onClick={handleTryLoadNewGame}>
          <i style={{color: gameConfig.gameOver && !gameConfig.win ? '#c62828' : '#1b5e20'}} className={`fa fa-${gameConfig.gameOver && !gameConfig.win ? 'sad-tear' : 'smile'}`} />
        </SmileBox>
      </div>
      <div style={{height: 40, width: 70}}>
        <DigitalNumber
          nums={('00' + (timer).toString()).slice(-3)}
          color='#FF0000'
          unActiveColor='#22221e'
          backgroundColor='#000000'
          transform
          transformDuration={0}
        />
      </div>
    </PanelBox>
  );
};

export default Panel;
